import { memo } from "react";

import useTypedContext from "hooks/useTypedContext";
import TableCell from "components/Table/Cell";
import { TableContext } from "components/Table/Context";

import { USED_BY_COLUMN_ID } from "../constants";
import RoleUsedByListItemDeleteActionCell from "./DeleteActionCell";
import RoleUsedByListItemNameCell from "./NameCell";
import RoleUsedByListItemTypeCell from "./TypeCell";
import RoleUsedByListItemSpaceCell from "./SpaceCell";
import { EntityWithRoleBinding } from "../types";

const CELLS = {
  [USED_BY_COLUMN_ID.TYPE]: RoleUsedByListItemTypeCell,
  [USED_BY_COLUMN_ID.NAME]: RoleUsedByListItemNameCell,
  [USED_BY_COLUMN_ID.SPACE]: RoleUsedByListItemSpaceCell,
  [USED_BY_COLUMN_ID.DELETE_ACTION]: RoleUsedByListItemDeleteActionCell,
};

type RoleUsedByListItemProps = {
  entity: EntityWithRoleBinding;
  roleName: string;
  readOnly?: boolean;
};

const RoleUsedByListItem = (props: RoleUsedByListItemProps) => {
  const { entity, roleName, readOnly } = props;

  const { visibleColumnIds } = useTypedContext(TableContext);

  return (
    <>
      {visibleColumnIds.map((id) => {
        const Component = CELLS[id as USED_BY_COLUMN_ID];
        const uniqueKey = `${id}-${entity.roleBindingId}`;

        const childrenComponent = (
          <Component entity={entity} roleName={roleName} readOnly={readOnly} />
        );

        return (
          <TableCell key={uniqueKey} id={id}>
            {childrenComponent}
          </TableCell>
        );
      })}
    </>
  );
};

export default memo(RoleUsedByListItem);
